export function parseVersion(version: string): [number, number, number, number] {
  const parts = version.split('.');
  const versionNumbers = parts.map((part) => {
    const num = parseInt(part, 10);
    if (isNaN(num)) {
      throw new Error(`Invalid number part in version: "${part}"`);
    }
    return num;
  });

  while (versionNumbers.length < 4) {
    versionNumbers.push(0);
  }

  return [versionNumbers[0], versionNumbers[1], versionNumbers[2], versionNumbers[3]];
}

/**
 * Compare two version strings.
 * Returns 1 if version1 > version2, -1 if version1 < version2, 0 if equal.
 */
export function compareVersions(version1: string, version2: string): number {
  const [major1, minor1, patch1, build1] = parseVersion(version1);
  const [major2, minor2, patch2, build2] = parseVersion(version2);

  if (major2 > major1) return -1;
  if (major2 < major1) return 1;

  if (minor2 > minor1) return -1;
  if (minor2 < minor1) return 1;

  if (patch2 > patch1) return -1;
  if (patch2 < patch1) return 1;

  if (build2 > build1) return -1;
  if (build2 < build1) return 1;

  return 0;
}
